"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var WixMarketplaceSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M7.5,3 C8.88071187,3 10,4.11928813 10,5.5 C10,6.22421339 9.69205803,6.87650309 9.19997081,7.33307237 C10.0358096,7.67397272 10.745981,8.25909389 11.2419752,8.99977951 L9.94928288,8.99979571 C9.43063228,8.49164319 8.75453296,8.1435831 8.00094991,8.03558044 L8.00070296,6.91439849 C8.58293192,6.70828193 9,6.1528467 9,5.5 C9,4.67157288 8.32842712,4 7.5,4 C6.67157288,4 6,4.67157288 6,5.5 C6,6.15321869 6.41754351,6.70891488 7.00029246,6.91475048 L7.00004975,8.03543731 C5.30387842,8.27803074 4,9.73674681 4,11.5 L4,12 L8,12 L8,10 C8,9.44771525 8.44771525,9 9,9 L14,9 C14.5522847,9 15,9.44771525 15,10 L15,14 C15,14.5522847 14.5522847,15 14,15 L6,15 L6,14 L8,14 L8,13 L4,13 C3.44771525,13 3,12.5522847 3,12 L3,11.5 C3,9.61637814 4.15731269,8.00306114 5.79966516,7.33232191 C5.30794197,6.87650309 5,6.22421339 5,5.5 C5,4.11928813 6.11928813,3 7.5,3 Z M14,10 L9,10 L9,14 L14,14 L14,10 Z" })));
};
WixMarketplaceSmall.displayName = 'WixMarketplaceSmall';
exports.default = WixMarketplaceSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=WixMarketplaceSmall.js.map